import { createElement } from "react";
import { Link } from "react-router-dom";

export const OCLink = ({ onClick, component = Link, ...rest }) => {
  const handleClick = e => {
    onClick?.(e);
  };

  return createElement(component, {
    ...rest,
    onClick: handleClick
  });
};
